import type {
  WElementFontView,
  WProjectCustomizationElementView,
  WCardTemplateElementView,
} from '@zola/svc-web-api-ts-client';

export const getFontLigatures = (
  textElement: WProjectCustomizationElementView | WCardTemplateElementView,
  fontSize: number,
  fontSupportsLigatures: boolean
) => {
  if (!textElement?.font) return 'none';

  let ligaturesMinFontSize = 0;
  if ('ligatures_minimum_font_size' in textElement.font) {
    ligaturesMinFontSize = textElement.font.ligatures_minimum_font_size || 0;
  }
  let characterSpacing = 0;
  if ('character_spacing' in textElement) {
    // This could be a bug, we might want to pull characterSpacing from textElement.font
    characterSpacing = textElement.character_spacing || 0;
  }

  if (!fontSupportsLigatures || characterSpacing > 0 || ligaturesMinFontSize > fontSize) {
    return 'none';
  }

  return 'common-ligatures';
};

export const createLigaturesByFontId = (fonts: WElementFontView[]) => {
  const ligaturesByFontId: Record<number, boolean> = {};

  fonts.forEach(font => {
    if (font.id) {
      ligaturesByFontId[font.id] = !!font.enable_ligatures;
    }
  });

  return ligaturesByFontId;
};
